import {Stack, Typography} from '@mui/material';
import React from 'react';

import emptySearchImg from 'presentation/assets/images/empty-search.svg';
import emptySearchV2Img from 'presentation/assets/images/empty-search-v2.svg';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {ImageContainer, StyledCard} from './styles';
import {EmptySearchStateProps} from './types';

const {emptySearchImage} = translations['pt-br'].commons;

export function EmptySearchState({
	title,
	customTitle,
	description,
	children,
	dataTagId,
	customMargin,
	customMaxWidthCard,
	customMaxWidthContent = 400,
	imageV2 = false,
	customFlexDirection,
	customWidthContent,
	noMarginImage,
	customJustifyContent,
	hideImage,
	...cardProps
}: EmptySearchStateProps) {
	const {isMobile} = useMediaQueries();
	return (
		<StyledCard
			elevation={0}
			data-tag-id={dataTagId}
			$maxWidth={customMaxWidthCard}
			$margin={customMargin}
			$flexDirection={customFlexDirection}
			$justifyContent={customJustifyContent}
			{...cardProps}>
			<Stack
				maxWidth={isMobile ? '100%' : customMaxWidthContent}
				width={customWidthContent ?? undefined}>
				<Typography variant="h6">{customTitle ?? title}</Typography>
				{description ? (
					<Typography color="text.primary" whiteSpace="pre-line" mt={0.5}>
						{description}
					</Typography>
				) : null}
				<Stack gap={1} mt={2}>
					{children}
				</Stack>
			</Stack>
			{hideImage ? null : (
				<ImageContainer $noMargin={noMarginImage}>
					<img src={imageV2 ? emptySearchV2Img : emptySearchImg} alt={emptySearchImage} />
				</ImageContainer>
			)}
		</StyledCard>
	);
}
